import { render, staticRenderFns } from "./IndexReleaseEvent.vue?vue&type=template&id=2d742a5a&scoped=true&"
import script from "./IndexReleaseEvent.vue?vue&type=script&lang=js&"
export * from "./IndexReleaseEvent.vue?vue&type=script&lang=js&"
import style0 from "./IndexReleaseEvent.vue?vue&type=style&index=0&id=2d742a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d742a5a",
  null
  
)

export default component.exports